import React from 'react';
import classNames from 'classnames';

import { PaddingContainer, WidthContainer } from '@components';
import iotAnimation from '@images/animations/iot-animation.json';

import * as styles from './Header.module.scss';
import Lottie from 'lottie-react';

export const Header: React.FC = () => {
	return (
		<PaddingContainer className="white-bg pb-0">
			<WidthContainer>
				<div className="row no-gutters">
					<div className="col-12 col-lg-6 mb-4 mb-lg-0">
						<h1
							className={classNames(
								styles.header,
								'font-size-large pb-2 mb-3 mt-0'
							)}
						>
							Internet of Things (IoT)
						</h1>
						<p className="font-size-sm pr-2 pr-sm-4 pr-md-0">
							Embedded Systems &#38; Hardware Development
						</p>
					</div>
					<div
						className={classNames(
							styles.animationBox,
							'col-12 col-lg-6 d-flex justify-content-center align-items-center'
						)}
					>
						<div className={classNames(styles.animationBoxInner, 'ml-lg-5')}>
							<Lottie animationData={iotAnimation} loop={true} />
						</div>
					</div>
				</div>
			</WidthContainer>
		</PaddingContainer>
	);
};
